import { render } from "./OrdersIcon.vue?vue&type=template&id=19f7deaa"
import script from "./OrdersIcon.vue?vue&type=script&lang=js"
export * from "./OrdersIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__